import { SG_EVENT_NAMES } from '@/utils/tools/segment/eventNames';
import { trackEvent } from '@/utils/tools/segment/tracking';
import { Button, Form, Input, Modal } from 'antd';
import { useEffect, useState } from 'react';

export default function NewFolderModal({ open, setOpen, parentFolder, library, ...props }) {
   const [form] = Form.useForm();
   const [loading, setLoading] = useState(false);
   const [folderName, setFolderName] = useState('');
   const [error, setError] = useState('');

   // Check for duplicate folder names
   useEffect(() => {
      if (!folderName.trim()) {
         setError('');
         return;
      }

      if (library.data && library.data.folders) {
         const existingFolder = library.data.folders.find(
            (folder) => folder.name.toLowerCase() === folderName.trim().toLowerCase()
         );

         if (existingFolder) {
            setError('A folder with this name already exists in this location');
         } else {
            setError('');
         }
      }
   }, [folderName, library.data]);

   // Reset error when modal opens
   useEffect(() => {
      if (open) {
         setFolderName('');
         setError('');
         form.resetFields();
      }
   }, [open, form]);

   async function handleSubmit() {
      if (error) return;

      const values = await form.validateFields();
      setLoading(true);

      try {
         await library.addNewFolder({
            name: values.name,
            color: '#ffd6a5',
            parentFolderId: parentFolder,
         });
         setLoading(false);
         setOpen(false);
         setFolderName('');
         setError('');
         form.resetFields();
         // track event
         trackEvent(SG_EVENT_NAMES.USER_CREATE_LIBRARY_FOLDER);
      } catch (error) {
         setLoading(false);
      }
   }

   return (
      <>
         <Modal
            title="New Folder"
            open={open}
            destroyOnClose={true}
            onCancel={() => {
               setOpen(false);
               form.resetFields();
               setFolderName('');
               setError('');
            }}
            footer={[
               <Button
                  key="back"
                  onClick={() => {
                     setOpen(false);
                     form.resetFields();
                     setFolderName('');
                     setError('');
                  }}
               >
                  Cancel
               </Button>,
               <Button
                  key="submit"
                  type="primary"
                  onClick={handleSubmit}
                  loading={loading}
                  disabled={!!error || !folderName.trim()}
               >
                  Create
               </Button>,
            ]}
            {...props}
         >
            <Form layout="vertical" form={form} onFinish={handleSubmit} preserve={false}>
               <Form.Item
                  name="name"
                  rules={[{ required: true, message: 'Please input folder name!' }]}
                  validateStatus={error ? 'error' : ''}
                  help={error}
               >
                  <Input
                     placeholder="Enter folder name"
                     value={folderName}
                     onChange={(e) => setFolderName(e.target.value)}
                  />
               </Form.Item>
            </Form>
         </Modal>
      </>
   );
}
